import { SectionTitle } from "gamfi/components/sectionTitle";
// import data from "gamfi/assets/data/social/dataV1";
import SocialStyleWrapper from "gamfi/sections/Footer/SocialProfile/SocialProfile.style";
import { FacebookShareButton, LinkedinShareButton, TelegramShareButton, TwitterShareButton } from "react-share";

import facebook from "gamfi/assets/images/icons/facebook.svg";
// import discord from "gamfi/assets/images/icons/discord.svg";
// import insta from "gamfi/assets/images/icons/insta.svg";
import linkedin from "gamfi/assets/images/icons/linkedin.svg";
// import medium from "gamfi/assets/images/icons/medium.svg";
import telegram from "gamfi/assets/images/icons/telegram.svg";
import twitter from "gamfi/assets/images/icons/twitter.svg";
import { exploded } from "utils/time";
import { metaverse } from "data/metaverse";
import { useAccount } from "wagmi";

const Social = () => {
  const { address, isConnected } = useAccount();
  const account = isConnected && address ? address : metaverse.owner;

  const socialUrl = exploded()
    ? `https://metaverse-energy.github.io/#/history`
    : `https://metaverse-energy.github.io/#/airdrop?ref=${account}`;

  const socialTitle = exploded()
    ? `Hey, don't miss out this amazing source of energy in the crypto space!`
    : `Hey, don't miss out this amazing airdrop!`;

  const socialHashtags = exploded()
    ? [`metaverse`, `energy`, `game`, `crypto`, `blockchain`]
    : [`bigbang`, `metaverse`, `game`, `crypto`, `blockchain`];

  return (
    <SocialStyleWrapper>
      <div className="container">
        <SectionTitle isCenter={true} subtitle="SHARE IN SOCIAL" title="" />
        <div className="social-link-list">
          <FacebookShareButton quote={socialTitle} url={socialUrl}>
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <a>
              <img src={facebook} alt="share in facebook" />
            </a>
          </FacebookShareButton>

          <LinkedinShareButton title={socialTitle} url={socialUrl}>
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <a>
              <img src={linkedin} alt="share in linkedin" />
            </a>
          </LinkedinShareButton>

          <TelegramShareButton title={socialTitle} url={socialUrl}>
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <a>
              <img src={telegram} alt="share in telegram" />
            </a>
          </TelegramShareButton>

          <TwitterShareButton title={socialTitle} url={socialUrl} hashtags={socialHashtags}>
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <a>
              <img src={twitter} alt="share in twitter" />
            </a>
          </TwitterShareButton>
        </div>
      </div>
    </SocialStyleWrapper>
  );
};

export default Social;
